import { Component, OnInit } from '@angular/core';
import { keyValuePair, property } from 'src/app/models';
import { ArchiveService } from 'src/app/services/services/archive.service';
import { configuration } from '../models';
import { forkJoin } from 'rxjs';
import { Store } from '@ngrx/store';
import { State } from 'src/app/dashboards/state';
import { ErrorMessage, InfoMessage } from 'src/app/common/messages';
import * as mainActions from 'src/app/state/app.actions'
import { I18NextPipe } from 'angular-i18next';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-archive-external-access-config',
    templateUrl: './archive-external-access-config.component.html',
    styleUrls: ['./archive-external-access-config.component.scss'],
    standalone: false
})
export class ArchiveExternalAccessConfigComponent implements OnInit {
  public configData: configuration = { footerText: '', multilingual: {en:{terms:""}}, sessionDuration: 1 };
  public langs: keyValuePair[] = []
  public terms: any = {};
  private file:File;
  public logo: any;
  constructor(private archiveService: ArchiveService,private i18nextPipe: I18NextPipe,private store: Store<State>, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.getConfig();
  }

  resetConfig() {
    this.getConfig();
  }
  saveConfig() {
    this.configData.sessionDuration = parseInt(this.configData.sessionDuration.toString());
    this.archiveService.saveExtAccessConfig(this.configData,this.file).subscribe( data=>{
      if (data.body && data.ok) {
     this.getConfig();
        this.store.dispatch(
          mainActions.addMessage({
            message: new InfoMessage(
              this.i18nextPipe.transform('messages:Configuration has been successfully saved.'), "")
          }));
      } else {
        this.store.dispatch(
          mainActions.addMessage({
            message: new ErrorMessage(
              this.i18nextPipe.transform('messages:Unable to save configuration!'),
              this.i18nextPipe.transform("messages:Please try again later."))
          }));
      }
    });
  }

  logoInputChange(fileInputEvent: any) {
    if (fileInputEvent.target.files && fileInputEvent.target.files[0]) {
      var reader = new FileReader();
      reader.onload = (e: any) => {
        this.logo = e.target.result;
      }
      reader.readAsDataURL(fileInputEvent.target.files[0]);
      this.file = fileInputEvent.target.files[0];
    }
  }

  getConfig() {
    forkJoin({
      config: this.archiveService.getExtAccessConfig(),
      langs: this.archiveService.getSupportedLanguages()
    }).subscribe(results => {
      this.configData = results.config;
      this.langs = results.langs;

      this.langs.forEach(la => {
        if (!this.configData.multilingual.hasOwnProperty(la.key)) {
          this.configData.multilingual[la.key] = { terms: "" };
        }
      });
      this.file = null;
      this.logo = null;
      this.archiveService.getArchiveServiceConfigLogo().subscribe((blob: Blob) => {
        if (blob && blob.size > 0) {
          let objectURL = URL.createObjectURL(blob);
          this.logo = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        }
      });
    });
  }
}
